import DialogManager from './manager'
import EDialogDialogLayout from './components/DialogLayout.vue'
import EDialogModalLayout from './components/ModalLayout.vue'
// import EDialogDialogActions from './components/DialogActions.vue'
// import EDialogConfirm from '../components/EDialog/Confirm.vue'
import EDialogBody from './components/DialogBody.vue'
import EModalBody from './components/ModalBody.vue'

function install(Vue, options = {}) {
  if (install.installed) return
  install.installed = true

  if (!options.container) {
    options.container = '[data-app="true"]'
  }

  const context = options.context || {}
  const defaultActionFunctions = () => ({
    close: {
      key: false,
      label: context.i18n ? () => context.i18n.t('cancel') : 'Cancel',
    },
    submit: {
      key: true,
      label: context.i18n ? () => context.i18n.t('ok') : 'OK',
    },
  })
  const actionsFn = options.actions || defaultActionFunctions()
  const actionOptions = options.actionOptions || {
    flat: true,
  }

  const manager = new DialogManager(options)

  manager.layout('default', EDialogDialogLayout)
  manager.layout('modal', EDialogModalLayout)
  // Vue.component('DialogActions', EDialogDialogActions)

  // manager.component('confirm', EDialogConfirm, {
  //   waitForResult: true,
  //   actions: actionsFn,
  //   actionsOverride: {},
  //   actionOptions: actionOptions,
  //   ...options.confirm,
  // })
  //
  // manager.component('warning', EDialogConfirm, {
  //   type: 'warning',
  //   waitForResult: true,
  //   actions: actionsFn,
  //   actionsOverride: {},
  //   actionOptions: actionOptions,
  //   ...options.warning,
  // })
  //
  // manager.component('error', EDialogConfirm, {
  //   type: 'error',
  //   waitForResult: true,
  //   actions: [defaultActionFunctions().true],
  //   actionsOverride: {},
  //   actionOptions: actionOptions,
  //   ...options.error,
  // })
  //
  // manager.component('info', EDialogConfirm, {
  //   type: 'info',
  //   waitForResult: true,
  //   actions: [defaultActionFunctions().true],
  //   actionsOverride: {},
  //   actionOptions: actionOptions,
  //   ...options.info,
  // })

  // manager.component('toast', EDialogToast, {
  //   waitForResult: true,
  //   actionOptions: actionOptions,
  //   actionsOverride: {},
  //   actions: {
  //     false: {
  //       text: context.i18n ? () => context.i18n.t('close') : 'Close',
  //     },
  //   },
  //   ...options.toast,
  // })

  manager.component('dialog', EDialogBody, {
    waitForResult: true,
    actions: actionsFn,
    actionsOverride: {},
    actionOptions: actionOptions,
    ...options.dialog,
  })

  manager.component('modal', EModalBody, {
    waitForResult: true,
    actions: actionsFn,
    actionsOverride: {},
    actionOptions: actionOptions,
    ...options.modal,
  })

  // manager.message = {
  //   info: (message, options) => manager.toast({ text: message, color: 'info', ...options }),
  //   error: (message, options) => manager.toast({ text: message, color: 'error', ...options }),
  //   success: (message, options) => manager.toast({ text: message, color: 'success', ...options }),
  //   warning: (message, options) => manager.toast({ text: message, color: 'warning', ...options }),
  // }

  Object.defineProperty(Vue.prototype, '$eDialog', {
    get() {
      return manager.dialog
    },
    configurable: true,
  })

  Object.defineProperty(Vue.prototype, '$eModal', {
    get() {
      return manager.modal
    },
    configurable: true,
  })
}

const Plugin = {
  install,
}

export default Plugin
